<div class="modal right" id="orderDetail" tabindex="-1" role="dialog" aria-labelledby="orderDetailLabel">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header hide-print">
                <div class="modal-title">
                    <h4 id="orderDetailLabel">Order ID</h4>
                    <span>{{ selectedWork.unique }}</span>
                </div>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <i class="icon-close-circle"></i>
                </button>
            </div>
            <div class="modal-body order-detail-page">
                <div class="loading" ng-if="loadingWork">
                    <div id="global_loader" class="glb-ldr-prt">
                        <div class="gl-ldr-cld">
                            <div class="gl-ldr-ctr">
                                <div class="gl-loader"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <ul class="nav nav-tabs nav-justified hide-print" id="tabContent">
                    <li class="active"><a target="_self" href="#workdetails" data-toggle="tab">Details</a></li>
                    <li ng-if="selectedWork.status && (selectedWork.status.value == 'complete' || selectedWork.status.value == 'fail' || selectedWork.status.value == 'failed' || selectedWork.status.value == 'cancel')">
                        <a target="_self" href="#proof" data-toggle="tab">Proof</span>
                    </a>
                    <li><a target="_self" href="#workactivity" data-toggle="tab">Activity</a></li>
                    <li><a target="_self" href="#worknotes" data-toggle="tab">Notes <span class="badge label label-danger" ng-if="(selectedWork.logs|filter: { proccess: 'note' }).length > 0">{{(selectedWork.logs|filter: { proccess: 'note' }).length}}</span></a>
                    </li>
                    <li class="pull-right">
                        <i class="fa fa-star fs15" ng-class="selectedWork.rate > $index ? 'text-warning' : ''" ng-repeat="i in getNumber(5) track by $index"></i>
                    </li>
                </ul>
                <div class="tab-content">
                    <div class="tab-pane active" id="workdetails">
                        <div class="modal-body-container">
                            <!-- <h4>Delivery Customer</h4> -->
                            <div class="row">
                                <div class="col-md-6 mt-2">
                                    <!--<div class="col-md-12" ng-if="can('maps')">-->
                                    <!--<div class="panel mb10">-->
                                    <!--<div class="panel-body">-->
                                    <!--<h4>Customer </h4>-->
                                    <!--<p>-->
                                    <!--<strong>Customer Name </strong> <span> {{ selectedWork.customer.customer_name }}</span>-->
                                    <!--</p>-->
                                    <!--<p>-->
                                    <!--<strong>Phone Number </strong> <span> {{ selectedWork.customer.phone_number }}</span>-->
                                    <!--</p>-->
                                    <!--<p>-->
                                    <!--<strong>Street Address </strong>-->
                                    <!--<span>-->
                                    <!--{{ selectedWork.customer.address }} - {{ selectedWork.customer.city }} {{ selectedWork.customer.state }} -->
                                    <!--</span>-->
                                    <!--</p>-->
                                    <!--<p>-->
                                    <!--<strong>Apartment, Unit, Suite, Building, Floor etc.</strong>-->
                                    <!--<span>-->
                                    <!--{{ selectedWork.customer.address_two }} -->
                                    <!--</span>-->
                                    <!--</p>-->
                                    <!--<p>-->
                                    <!--<strong>City / State / Zipcode</strong>-->
                                    <!--<span>-->
                                    <!--{{ selectedWork.customer.city ? selectedWork.customer.city '-' }} / {{ selectedWork.customer.state ? selectedWork.location.state '-' }} / {{ selectedWork.location.zipcode ? selectedWork.location.zipcode '-' }}-->
                                    <!--</span>-->
                                    <!--</p>-->
                                    <!--<div ng-show="can('maps')" ng-if="sendSmsCustomer">-->
                                    <!--<div class="form-group" ng-show="can('maps')">-->
                                    <!--<label class="mb10">Send Sms</label>-->
                                    <!--<label class="field">-->
                                    <!--<textarea name="sms" ng-model="sms_content" id="smsContent"-->
                                    <!--class="form-control" placeholder="Sms İçeriği"-->
                                    <!--cols="30" rows="5"></textarea>-->
                                    <!--</label>-->
                                    <!--</div>-->
                                    <!--<div class="form-group" ng-if="can('maps')">-->
                                    <!--<a href="#" ng-click="sendSms(sms_content, 'customer')"-->
                                    <!--class="btn btn-sm btn-success">Gönder</a>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <!--<p ng-show="can('maps')">-->
                                    <!--<a href="" class="btn btn-sm btn-primary" ng-if="!sendSmsCustomer"-->
                                    <!--ng-click="changeVariable('sendSmsCustomer',true)">SMS Gönder</a>-->
                                    <!--</p>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <!--</div>-->
                                    <div class="print-modal-customer">
                                        <div class="panel mb10">
                                            <p ng-if="selectedWork.sender">
                                                <strong>Sender </strong>
                                                <span> {{ selectedWork.sender }}</span>
                                            </p>
                                            <p>
                                                <strong>Name </strong>
                                                <span> {{ selectedWork.location.name }}</span>
                                            </p>
                                            <p>
                                                <strong>Phone Number </strong> <span> {{ selectedWork.location.phone_number | tel }}</span>
                                            </p>
                                            <p>
                                                <strong>Email </strong>
                                                <span> {{ selectedWork.location.email || "-" }}</span>
                                            </p>
                                            <div ng-show="can('maps')" ng-if="sendSmsLocation">
                                                <div class="form-group" ng-show="can('maps')">
                                                    <label class="mb10">SMS Gönder</label>
                                                    <label class="field">
                                                        <textarea name="sms" ng-model="sms_content2" id="smsContent2" class="form-control" placeholder="Sms İçeriği" cols="30" rows="5"></textarea>
                                                    </label>
                                                </div>
                                                <div class="form-group" ng-if="can('maps')">
                                                    <a href="#" ng-click="sendSms(sms_content2, 'location')" class="btn btn-sm btn-success">Gönder</a>
                                                </div>
                                            </div>
                                            <div ng-show="can('maps')" ng-if="addCallRecord">
                                                <div class="form-group" ng-show="can('maps')">
                                                    <label class="mb10">Çağrı Kaydı Ekle</label>
                                                    <label class="field">
                                                        <textarea name="callRecord" ng-model="reason" id="callRecord" class="form-control" placeholder="Kayıt Detayı" cols="30" rows="5"></textarea>
                                                    </label>
                                                </div>
                                                <div class="form-group" ng-if="can('maps')">
                                                    <a href="#" ng-click="sendCallRecord(reason, 'customer')" class="btn btn-sm btn-success">Gönder</a>
                                                </div>
                                            </div>
                                            <!-- <p ng-show="can('maps')">
                                                <a href="" class="btn btn-sm btn-primary" ng-if="!sendSmsLocation" ng-click="changeVariable('sendSmsLocation',true)">SMS Gönder</a>
                                                <a href="" class="btn btn-sm btn-default" ng-if="!addCallRecord" ng-click="changeVariable('addCallRecord',true)">Çağrı Kaydı Gir</a>
                                            </p> -->
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 mt-2">
                                    <div class="print-modal-customer">
                                        <div class="panel mb-10">
                                            <p>
                                                <strong>Street Address </strong>
                                                <span>
                                                    {{ selectedWork.location.address }}
                                                </span>
                                            </p>
                                            <p>
                                                <strong>Apartment, Suite, Building</strong>
                                                <span>
                                                    {{ selectedWork.location.address_two }}
                                                </span>
                                            </p>
                                            <p>
                                                <strong>City / State / Zipcode </strong>
                                                <span>
                                                    {{ selectedWork.location.city ? selectedWork.location.city : '-' }} / {{ selectedWork.location.state ? selectedWork.location.state : '-' }} / {{ selectedWork.location.zipcode ? selectedWork.location.zipcode : '-' }}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6 mt-3">
                                    <div class="panel">
                                        <p class="hidden order-id">
                                            <strong>Order ID </strong>
                                            <span>#{{ selectedWork.unique }}</span>
                                        </p>
                                        <p>
                                            <strong>Station </strong>
                                            <span>{{ selectedWork.station.code }} - {{ selectedWork.station.city }}</span>
                                        </p>
                                        <p>
                                            <strong>Weight </strong>
                                            <span>{{ selectedWork.weight }}</span>
                                        </p>
                                        <p>
                                            <strong>Number of Piece(s) </strong>
                                            <span>{{ selectedWork.piece }}</span>
                                        </p>
                                        <p>
                                            <strong>Special Instructions </strong>
                                            <span>
                                                <span ng-if="selectedWork.special_value" ng-bind-html="selectedWork.special_value | trust"></span>
                                                <span ng-if="!selectedWork.special_value"> - </span>
                                                <!-- <span ng-if="!selectedWork.special_value"> - </span> -->
                                            </span>
                                        </p>
                                        <p ng-if="selectedWork.delivery_instructions">
                                            <strong>Delivery Instructions </strong>
                                            <span>
                                                <span ng-if="selectedWork.delivery_instructions" ng-bind-html="selectedWork.delivery_instructions | trust"></span>
                                                <span ng-if="!selectedWork.delivery_instructions"> - </span>
                                            </span>
                                        </p>
                                        <p ng-if="selectedWork.work_type">
                                            <strong>Type </strong>
                                            <span>{{ selectedWork.work_type.name }}</span>
                                        </p>
                                        <p ng-if="can('maps')">
                                            <strong>Rate / Tip </strong>
                                            <span>
                                                <span>{{ selectedWork.rate ? selectedWork.rate : '-' }} / </span>
                                                <span>{{ selectedWork.tip ? '$'+selectedWork.tip : '-' }} </span>
                                                <!-- <span ng-if="!selectedWork.special_value"> - </span> -->
                                            </span>
                                        </p>
                                        <!--<div ng-if="selectedWork.receiver">-->
                                        <!--<strong ng-if="selectedWork.receiver.status"-->
                                        <!--style="color:green">Receiver </strong>-->
                                        <!--<strong ng-if="!selectedWork.receiver.status" style="color:red">Cancellation-->
                                        <!--Reason </strong>-->
                                        <!--<span>{{ selectedWork.receiver.reason }}</span>-->
                                        <!--<a href="#" ng-click="openImage(selectedWork.receiver.image)">-->
                                        <!--<img-->
                                        <!--ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ selectedWork.receiver.image }}"-->
                                        <!--alt="image"-->
                                        <!--width="200px"-->
                                        <!--class="img-responsive img-thumbnail"-->
                                        <!--ng-if="selectedWork.receiver.image">-->
                                        <!--</a>-->
                                        <!--<a href="#"-->
                                        <!--ng-click="openImage(selectedWork.receiver.signature)">-->
                                        <!--<img-->
                                        <!--ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ selectedWork.receiver.signature }}"-->
                                        <!--alt="signature"-->
                                        <!--width="200px"-->
                                        <!--class="img-responsive img-thumbnail"-->
                                        <!--ng-if="selectedWork.receiver.signature">-->
                                        <!--</a>-->
                                        <!--</div>-->
                                        <p>
                                            <div class="pull-left" ng-repeat="item in selectedWork.items_code">
                                                <img class="qrcode-thumb" ng-src="{{ item.qr }}" alt="">
                                                <p style="text-transform: uppercase;">{{ item.code }}</p>
                                                <div class="qrcode">
                                                    <img ng-src="{{ item.qr }}" alt="">
                                                </div>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6 mt-3">
                                    <div class="panel">
                                        <p>
                                            <strong>Product Details </strong>
                                            <span>
                                                <span ng-if="selectedWork.name && selectedWork.name !== null" ng-bind-html="selectedWork.name | trust"></span>
                                                <span ng-if="!selectedWork.name">No Details</span>
                                            </span>
                                            <div ng-if="selectedWork.lines.length > 0">
                                                <table class="table table-hover table-striped">
                                                    <thead>
                                                        <tr class="bg-light">
                                                            <th class="text-center">Name</th>
                                                            <th class="text-center">Qty</th>
                                                            <th class="text-center">Price</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr ng-repeat="item in selectedWork.lines">
                                                            <td class="text-center">{{ item.name }}</td>
                                                            <td class="text-center">{{ item.qty | number:0 }}</td>
                                                            <td class="text-center" ng-if="selectedWork.source === 'uber'">${{ item.price / 100 | number:2 }}</td>
                                                            <td class="text-center" ng-if="selectedWork.source !== 'uber'">${{ item.price | number:2 }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </p>
                                        <p ng-if="selectedWork.note_from_driver">
                                            <strong>Note From Driver </strong>
                                            <span>
                                                {{ selectedWork.note_from_driver.reason }}
                                            </span>
                                        </p>
                                        <p>
                                            <strong>Driver </strong>
                                            <!-- <img ng-if="item.worker" ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ selectedWork.worker.profile_photo }}" class="img-responsive text-center img-circle" style="width:36px;height:36px;float:left"> -->
                                            <span>
                                                {{ selectedWork.worker ? selectedWork.worker.full_name : '-' }}
                                            </span>
                                        </p>
                                        <p>
                                            <strong>Order Status </strong>
                                            <span ng-if="selectedWork.status" ng-style="{'color': selectedWork.status.color }">
                                                {{ selectedWork.status.name }}
                                            </span>
                                            <span ng-if="!selectedWork.status">Created</span>
                                        </p>
                                        <p>
                                            <strong>Created At </strong> <span>{{ selectedWork.created_at | amUtc | amDateFormat:'MM/DD/YYYY, hh:mm A' }} </span>
                                        </p>
                                        <p>
                                            <strong>Source </strong> 
                                            <span>{{ selectedWork.source }} </span>
                                            <span ng-if="selectedWork.uber_order_map">{{ selectedWork.uber_order_map.uber_order_id }} </span>
                                            <strong ng-if="selectedWork.uber_order_map">{{ selectedWork.uber_order_map.order_type }} </strong>
                                            <strong ng-if="selectedWork.doordash_order_map">{{ selectedWork.doordash_order_map.mail_order_id }} </strong>
                                            <strong ng-if="selectedWork.delivery_mail_order_map">{{ selectedWork.delivery_mail_order_map.mail_order_id }} </strong>
                                        </p>
                                        <p ng-repeat="item in selectedWork.fields_values">
                                            <strong>{{ item.field.name }} </strong>
                                            <span>{{ item.value }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" ng-if="selectedWork.signature.length != 0">
                                <div class="col-md-12">
                                    <div class="panel mb10">
                                        <p>
                                            <strong>Müşteri İmzası </strong>
                                            <img ng-src="{{ selectedWork.signature }}" alt="İmza" width="200px">
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" ng-if="selectedWork.images.length > 0">
                                <div class="col-md-12">
                                    <div class="panel mb10">
                                        <p>
                                            <strong>Resimler </strong>
                                            <div class="row">
                                                <div class="col-md-4" ng-repeat="item in selectedWork.images" ng-init="showImageDetail[$index] = false">
                                                    <a ng-click="openLightboxModal($index)">
                                                        <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.url }}" class="img-responsive img-thumbnail">
                                                        <a href="#" ng-if="!showImageDetail[$index]" ng-click="showImageDetail[$index] = true">
                                                            <i class="fa fa-plus"></i> Detaylar</a>
                                                        <a href="#" ng-if="showImageDetail[$index]" ng-click="showImageDetail[$index] = false">
                                                            <i class="fa fa-minus"></i> Gizle</a>
                                                        <div ng-if="showImageDetail[$index]">
                                                            <small><i class="fa fa-clock-o"></i> {{ item.created_at | amUtc | amDateFormat:'MM/DD/YYYY, hh:mm A' }}
                                                            </small>
                                                            <address><i class="fa fa-address-card-o"></i> {{ item.address }}</address>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="row" ng-if="selectedWork.form">
                                <div class="col-md-12">
                                    <div class="panel mb10">
                                        <p>
                                            <strong>Form Adı </strong>
                                            <span> {{ selectedWork.form.name }}</span>
                                        </p>
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th class="w200 fw600">Alan Adı</th>
                                                    <th class="w200 fw600">Sonuç</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr ng-repeat="item in selectedWork.form.fields">
                                                    <td>{{ item.field_name }}</td>
                                                    <td ng-if="item.field_type == 'image'">
                                                        <a href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.value.value }}" target="__BLANK" ng-if="item.value.value.length > 0">
                                                            <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.value.value }}" class="img-thumbnail col-md-3">
                                                        </a>
                                                        <span ng-if="item.value.value.length == 0">Resim Eklenmemiş</span>
                                                    </td>
                                                    <td ng-if="item.field_type != 'image' && item.field_type != 'date' && item.field_type != 'checkbox'">
                                                        <span ng-if="item.value.value.length > 0">{{ item.value.value }}</span>
                                                        <span ng-if="item.value.value.length == 0">Bilgi Girilmemiş</span>
                                                    </td>
                                                    <td ng-if="item.field_type == 'date'">
                                                        <span ng-if="item.value.value.length > 0">{{ item.value.value | amUtc | amDateFormat:'MM/DD/YYYY' }}</span>
                                                        <span ng-if="item.value.value.length == 0">Bilgi Girilmemiş</span>
                                                    </td>
                                                    <td ng-if="item.field_type == 'checkbox'">
                                                        <span ng-if="item.value.value.length > 0" ng-repeat="i in getCheckbox(item.value.value) track by $index ">{{ i }} ,</span>
                                                        <span ng-if="item.value.value.length == 0">Bilgi Girilmemiş</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 mt20 pr25 pln hide-print" ng-if="can('maps')">
                                    <a href="#" data-dismiss="modal" data-toggle="modal" data-target="#assignWorker" class="btn btn-primary mb15">Assign
                                    </a>
                                    <a href="#" data-dismiss="modal" data-toggle="modal" data-target="#changeWorkStatus" class="btn btn-primary mb15">Change Status
                                    </a>
                                    <!-- <a href="#" data-dismiss="modal" data-toggle="modal" data-target="#newOrder" ng-click="duplicateWork()" class="btn btn-primary mb15">KARGOYU KOPYALA
                                    </a> -->
                                    <a href="#" 
                                        data-dismiss="modal" 
                                        data-toggle="modal"
                                        data-target="#newOrder"
                                        ng-click="updateWork()"
                                        class="btn btn-primary mb15">
                                        Edit
                                    </a>
                                    <a href="#" 
                                        ng-if="!selectedWork.status || (selectedWork.status && (selectedWork.status.value != 'complete' && selectedWork.status.value != 'fail'))"
                                        data-dismiss="modal" 
                                        data-toggle="modal"
                                        data-target="#orderCancelReason"
                                        ng-click="setCancelOrder(selectedWork.id)"
                                        class="btn btn-primary mb15">
                                        Cancel
                                    </a>
                                    <a href="#" ng-if="authenticatedUser.owner" data-dismiss="modal" data-toggle="modal" data-target="#deleteWork" class="btn mb15">Delete</a>
                                    <!-- <a href="/is-yazdir/{{ selectedWork.id }}" target="__BLANK" class="btn btn-default mb15">KARGOYU Yazdır</a> -->
                                    <a href="#" ng-click="printOrder(selectedWork.id)" class="btn mb15">Print</a>
                                    
                                    <ul class="list-group">
                                        <li class="list-group-item" ng-repeat="item in selectedWork.notifications">
                                            <i class="fa fa-bell-o"></i>
                                            {{ item.time }}
                                            <span ng-if="item.period == 'minute'">Dk</span>
                                            <span ng-if="item.period == 'hour'">Saat</span>
                                            <span ng-if="item.period == 'day'">Gün</span>
                                            önce
                                            <span ng-if="item.type == 'push'">Mobil Bildirim</span>
                                            <span ng-if="item.type == 'sms'">Sms</span>
                                            ile
                                        </li>
                                    </ul>
                                </div>
                                <div class="ml-2 mt-3" ng-if="!can('maps')">
                                    <a href="#" ng-click="printOrder(selectedWork.id)" class="btn btn-default mb15">Print</a>
                                    <!-- <a href="#" ng-click="printDeliveryOrder(selectedWork.id)" class="btn mb15">Print On-Demand Label</a> -->

                                    <a href="#" 
                                        data-dismiss="modal" 
                                        data-toggle="modal"
                                        data-target="#newOrder"
                                        ng-if="!selectedWork.status || (selectedWork.status && (selectedWork.status.value != 'complete' && selectedWork.status.value != 'fail'))"
                                        ng-click="updateWork('customer')"
                                        class="btn btn-primary mb15">
                                        Edit
                                    </a>
                                    <a href="#" 
                                        ng-if="!selectedWork.status || (selectedWork.status && (selectedWork.status.value != 'complete' && selectedWork.status.value != 'fail'))"
                                        data-dismiss="modal" 
                                        data-toggle="modal"
                                        data-target="#orderCancelReason"
                                        ng-click="setCancelOrder(selectedWork.id)"
                                        class="btn btn-primary mb15">
                                        Cancel
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="tab-pane" id="workactivity">
                        <div class="modal-body-container">
                            <div id="timeline" class="timeline-single">
                                <div class="row">
                                    <div class="col-sm-12 left-column">
                                        <div class="timeline-item" ng-repeat="log in selectedWork.logs|filter: { proccess: '!note' }">
                                            <div class="timeline-icon">
                                                <span></span>
                                            </div>
                                            <div class="row">
                                                    <div class="col-md-12" ng-if="log.proccess == 'rate'">
                                                        <p>
                                                            Müşteri tarafından <i class="fa fa-star"></i> {{
                                                            selectedWork.rate }} Puan verildi. <br>
                                                            <strong>Yorum : {{ log.reason ? log.reason : 'Yorum
                                                                Yapılmadı.' }}</strong>
                                                        </p>
                                                        <br />
                                                        <small>
                                                            {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                            {{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
                                                        </small>
                                                    </div>
                                                    <div class="col-md-12" ng-if="log.proccess == 'edit'">
                                                        <span>Order info updated by <strong>{{ log.user.full_name }}</strong> </span>
                                                        <br />
                                                        <small>
                                                            {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                            {{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
                                                        </small>
                                                    </div>
                                                    <div class="col-md-12" ng-if="
                                                            log.proccess != 'edit' && 
                                                            log.proccess != 'rate' && 
                                                            log.proccess != 'create' && 
                                                            log.proccess != 'change_date' &&
                                                            log.proccess != 'change_worker' &&
                                                            log.proccess != 'assign_worker' &&
                                                            log.proccess != 'sending_sms' &&
                                                            log.proccess != 'call_record' &&
                                                            log.proccess != 'waiting_start' &&
                                                            log.proccess != 'waiting_end' &&
                                                            log.proccess != 'change_order_fields'
                                                    ">
                                                        <span>Order status changed to 
                                                            <strong ng-if="log.status" ng-style="{'color': log.status.color }">
                                                                "{{ log.status.name }}"
                                                            </strong> by
                                                            <strong>{{ log.user.full_name }}</strong>
                                                        </span>
                                                        
                                                        <span ng-if="log.status.value == 'fail'">
                                                            <br /><strong>Fail Reason : </strong> {{ log.reason ? log.reason : '-' }}
                                                            <br /><strong>Proof : </strong>
                                                            <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ log.url }}" class="img-responsive img-thumbnail media-photo">
                                                        </span>
                                                        <br />
                                                        <small>
                                                            {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                            {{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
                                                        </small>
                                                    </div>
                                                    <div class="col-md-12" ng-if="log.proccess == 'create'">
                                                        <span>Order <strong>Created</strong> by <strong>{{ log.user.full_name }}</strong> </span>
                                                        <br />
                                                        <small>
                                                            {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                            {{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
                                                        </small>
                                                    </div>
                                                    <div class="col-md-12" ng-if="log.proccess == 'change_date'">
                                                        <span><strong>{{ log.user.full_name }}</strong> tarafından <strong>kargo tarihi değiştirildi</strong></span>
                                                        <br />
                                                        <br />
                                                        <strong>Değiştirme Nedeni </strong> {{ log.reason ? log.reason :
                                                        '-' }}
                                                        <br />
                                                        <small>
                                                            {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                            {{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
                                                        </small>
                                                    </div>
                                                    <div class="col-md-12" ng-if="log.proccess == 'change_worker'">
                                                        <span><strong>{{ log.user.full_name }}</strong> tarafından <strong>kargo devredildi.</strong></span>
                                                        <br />
                                                        <br />
                                                        <strong>Devretme Nedeni : </strong> {{ log.reason ? log.reason :
                                                        '-' }}
                                                        <br />
                                                        <small>
                                                            {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                            {{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
                                                        </small>
                                                    </div>
                                                    <div class="col-md-12" ng-if="log.proccess == 'assign_worker'">
                                                        <span>Order assigned by <strong>{{ log.user.full_name }}</strong> to <strong>{{ log.worker.full_name }}</strong> </span>
                                                        <br />
                                                        <small>
                                                            {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                            {{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
                                                        </small>
                                                    </div>
                                                    <div class="col-md-12" ng-if="log.proccess == 'sending_sms'">
                                                        <span><strong>Sms sent</strong> by <strong>{{ log.user.full_name }}</strong>  </span>
                                                        <br />
                                                        <br />
                                                        {{ log.reason ? log.reason : '-' }}
                                                        <br />
                                                        <small>
                                                            {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                            {{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
                                                        </small>
                                                    </div>
                                                    <div class="col-md-12" ng-if="log.proccess == 'call_record'">
                                                        <span><strong>{{ log.user.full_name }}</strong> tarafından <strong> Çağrı Kaydı eklendi.</strong> </span>
                                                        <br />
                                                        <br />
                                                        <strong>Çağrı Detayı </strong> {{ log.reason ? log.reason :
                                                        '-' }}
                                                        <br />
                                                        <small>
                                                            {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                            {{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
                                                        </small>
                                                    </div>
                                                    <div class="col-md-12" ng-if="log.proccess == 'waiting_start'">
                                                        <span><strong>{{ log.user.full_name }}</strong> tarafından <strong> iş bekleme durumuna alındı.</strong></span>
                                                        <br />
                                                        <br />
                                                        {{ log.reason ? log.reason : '-' }}
                                                        <br />
                                                        <small>
                                                            {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                            {{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
                                                        </small>
                                                    </div>
                                                    <div class="col-md-12" ng-if="log.proccess == 'waiting_end'">
                                                        <span><strong>{{ log.user.full_name }}</strong> tarafından <strong> iş bekleme durumundan çıkarıldı.</strong></span>
                                                        <br />
                                                        {{ log.reason ? log.reason : '-' }}
                                                        <br />
                                                        <small>
                                                            {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                            {{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
                                                        </small>
                                                    </div>
                                                    <div class="col-md-12" ng-if="log.proccess == 'change_order_fields'">
                                                        <span><strong>{{ log.user.full_name }}</strong> tarafından <strong>kargo özel alanı değiştirildi.</strong></span>
                                                        <br />
                                                        <small>
                                                            {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                            {{ log.created_at | amUtc | amDateFormat:'hh:mm A' }}
                                                        </small>
                                                    </div>
                                                </div>
                                        </div>
                                        <div class="timeline-item" ng-if="selectedWork.logs.length == 0">
                                            <div class="timeline-icon">
                                                <span class="fa fa-times"></span>
                                            </div>
                                            <div class="panel">
                                                <div class="panel-body p20 pt10 pb10">
                                                    <div class="row">
                                                        <div class="col-md-12">
                                                            <span>No Activity Found</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane" id="worknotes">
                        <div class="modal-body-container">
                            <div class="chat-window">
                                <div class="panel panel-default pt-0">
                                    <div class="msg_container_base">
                                        <div class="row msg_container base_receive" ng-repeat="log in selectedWork.logs|filter:{ proccess: 'note' }">
                                            <div class="col-md-12 col-xs-12">
                                                <div class="messages msg_receive">
                                                    <p>{{ log.reason }}</p>
                                                    <a href="">{{ log.user.full_name }} -- <time datetime="2009-11-13T20:00">{{ log.created_at  | amUtc | amDateFormat:'MM/DD/YYYY, hh:mm A' }}</time></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row msg_container base_receive" ng-if="(selectedWork.logs|filter:{ proccess: 'note' }).length == 0">
                                            <div class="col-md-12 col-xs-12">
                                                <div class="messages msg_receive">
                                                    <p>No notes have been entered yet.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer-container">
                            <div class="input-group">
                                <input ng-model="description" type="text" id="noteInput" class="form-control input-sm chat_input" placeholder="Write a note" ng-disabled="noteAdding" />
                                <span class="input-group-btn">
                                    <a href="" ng-click="sendComment(description)" class="btn btn-primary btn-sm" id="btn-chat">Send</a>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane" id="proof">
                        <div class="modal-body-container">
                            <!-- <h4>{{ selectedWork.receiver.reason }}</h4> -->
                            <div class="row">
                                <div class="col-md-6 mt-3" ng-if="selectedWork.status.value != 'failed' && selectedWork.status.value != 'cancel'">
                                    <div class="panel">
                                        <p>
                                            <strong>Full Name</strong>
                                            <span>{{ selectedWork.location ? selectedWork.location.name : '-' }}</span>
                                        </p>
                                        <p>
                                            <strong>Delivered To</strong>
                                            <span>{{ selectedWork.receiver ? selectedWork.receiver.reason : '-' }}</span>
                                        </p>
                                        <p>
                                            <strong>Delivered At</strong>
                                            <span>{{ selectedWork.delivered_at | amUtc | amDateFormat:'MM/DD/YYYY, hh:mm A'  }}</span>
                                        </p>
                                        <p>
                                            <strong>Delivered By</strong>
                                            <span>{{ selectedWork.worker ? selectedWork.worker.full_name : '-' }}</span>
                                        </p>
                                        
                                    </div>
                                    <div class="ml-2 mt-3">
                                        <a href="" ng-click="exportProof()" ng-disabled="exportProofLoad" class="btn btn-default mb15">Export</a>
                                    </div>
                                </div>
                                <div class="col-md-6 mt-3" ng-if="selectedWork.status.value == 'failed' || selectedWork.status.value == 'cancel'">
                                    <div class="panel">
                                        <p>
                                            <strong>Reason</strong>
                                            <span>{{ selectedWork.receiver ? selectedWork.receiver.reason : '-' }}</span>
                                        </p>
                                        <p>
                                            <strong>Cancelled At</strong>
                                            <span>{{ selectedWork.receiver.created_at | amUtc | amDateFormat:'MM/DD/YYYY, hh:mm A'  }}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6 mt-3">
                                    <div class="panel">
                                        <div ng-if="selectedWork.receiver && selectedWork.receiver.signature != null">
                                            <strong>Signature </strong> <br>
                                            <div>
                                                <a href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ selectedWork.receiver.signature }}" target="__BLANK" >
                                                    <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ selectedWork.receiver.signature }}" alt="" width="120px">
                                                </a>
                                            </div>
                                        </div>
                                        <div ng-if="selectedWork.receiver && selectedWork.receiver.image != null">
                                            <strong>Image </strong> <br>
                                            <div>
                                                <a href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ selectedWork.receiver.image }}" target="__BLANK" >
                                                    <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ selectedWork.receiver.image }}" alt="" width="120px">
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="row" ng-repeat="receiver in selectedWork.all_receivers">
                                <div class="col-md-6 mt-3" ng-if="receiver.status">
                                    <div class="panel">
                                        <p>
                                            <strong>Full Name</strong>
                                            <span>{{ selectedWork.location ? selectedWork.location.name : '-' }}</span>
                                        </p>
                                        <p>
                                            <strong>Delivered To</strong>
                                            <span>{{ receiver.reason }}</span>
                                        </p>
                                        <p>
                                            <strong>Delivered At</strong>
                                            <span>{{ receiver.created_at | amUtc | amDateFormat:'MM/DD/YYYY, hh:mm A'  }}</span>
                                        </p>
                                        <p>
                                            <strong>Delivered By</strong>
                                            <span>{{ selectedWork.worker ? selectedWork.worker.full_name : '-' }}</span>
                                        </p>
                                        
                                    </div>
                                    <div class="ml-2 mt-3">
                                        <a href="" ng-click="exportProof()" ng-disabled="exportProofLoad" class="btn btn-default mb15">Export</a>
                                    </div>
                                </div>
                                <div class="col-md-6 mt-3" ng-if="!receiver.status">
                                    <div class="panel">
                                        <p>
                                            <strong>Reason</strong>
                                            <span>{{ receiver.reason }}</span>
                                        </p>
                                        <p>
                                            <strong>Cancelled At</strong>
                                            <span>{{ receiver.created_at | amUtc | amDateFormat:'MM/DD/YYYY, hh:mm A'  }}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-6 mt-3">
                                    <div class="panel">
                                        <div ng-if="receiver.signature != null">
                                            <strong>Signature </strong> <br>
                                            <div>
                                                <a href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ receiver.signature }}" target="__BLANK" >
                                                    <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ receiver.signature }}" alt="" width="120px">
                                                </a>
                                            </div>
                                        </div>
                                        <div ng-if="receiver.image != null">
                                            <strong>Image </strong> <br>
                                            <div>
                                                <a href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ receiver.image }}" target="__BLANK" >
                                                    <img ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ receiver.image }}" alt="" width="120px">
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
